export const toastConstants = {
    ENQUEUE_TOAST: 'ENQUEUE_TOAST',
}



// WEBPACK FOOTER //
// ./src/redux/constants/toast.constants.js